The partner's unique identifier for the position that failed to sync.

This corresponds to the `seekPartnerPositionId` provided in the input.
